export const LYRICS_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.LyricsWidgetElement';
